import { getDashboardFromAdapter } from 'application/adapters/ecommerce/dashboardAdapter';

export const getDashboard = async (accessToken: string, bpId: string) => {
	const dashboard = await getDashboardFromAdapter(accessToken, bpId);

	return dashboard;
};
